module.exports = __webpack_public_path__ + "img/battery-quarter.98fdf915.svg";